import React from 'react';
import './cn-demo-description.scss';
const CnDemoDescription = (props) => {
    return React.createElement("div", { className: "cn-ui-m-demo-description" }, props.children);
};
export default CnDemoDescription;
